import _extends from "@babel/runtime/helpers/esm/extends";

/** @jsx jsx */
import { jsx } from '@theme-ui/core';

var Spinner = function Spinner(props) {
  return jsx("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M22.4 6C19.1.3 11.7-1.7 6 1.6.3 4.9-1.7 12.3 1.6 18s10.6 7.7 16.4 4.4c5.7-3.3 7.7-10.7 4.4-16.4zM2.9 17.2C0 12.2 1.7 5.8 6.7 2.9c5-2.9 11.4-1.2 14.4 3.8 2.9 5 1.2 11.4-3.8 14.4-5.1 2.9-11.5 1.1-14.4-3.9z",
    fill: "#f6f9fd"
  }), jsx("path", {
    d: "M1.6 18C-1.7 12.3.3 4.9 6 1.6l.7 1.3c-5 2.9-6.7 9.3-3.8 14.3l-1.3.8z",
    fill: "#3096de"
  }, jsx("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 12 12",
    to: "360 12 12",
    dur: "0.5s",
    repeatCount: "indefinite"
  })));
};

export { Spinner };